import React from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { selectIsAuthenticated } from '~modules/auth/store/auth-selectors';

import { selectIsTenantAuthenticated } from '~tenant-modules/auth/store/tenant-auth-selectors';

import { useAppSelector } from '~system/store/configure-store';

import { ROUTES } from '~app/router/routes';

export const TenantPrivateRoute = () => {
  const isTenantAuthenticated = useAppSelector(selectIsTenantAuthenticated);
  const isLessorAuthenticated = useAppSelector(selectIsAuthenticated);

  const location = useLocation();

  const route = isLessorAuthenticated ? ROUTES.DASHBOARD : ROUTES.TENANT_LOGIN;

  if (isLessorAuthenticated && isTenantAuthenticated) {
    return <Navigate to={ROUTES.TENANT_SCOPE} replace />;
  }

  if (!isTenantAuthenticated) {
    const redirectTo = encodeURIComponent(
      location.pathname + location.search + location.hash,
    );

    return <Navigate to={`${route}?redirectTo=${redirectTo}`} replace />;
  }

  return <Outlet />;
};
